










import { Vue, Component } from 'vue-property-decorator';
import Dispositivo from '@/pantallas/Dispositivos/Dispositivo.vue';

@Component({
  components: { Dispositivo },
})
export default class DispositivoPantalla extends Vue {}
